import React, { useState } from 'react';
import { Add } from '@mui/icons-material';
import { Box, Button } from '@mui/material';

import FormDrawer from 'components/Shared/FormDrawer';
import ShipmentItemsList from './ShipmentItemsList';
import ShipmentItemsForm from './ShipmentItemsForm';
import { useShipmentDetailContext } from 'contexts/ShipmentDetailContext';
import { useUpdateShipmentMutation } from 'store/services/shipmentApi';
import { useAuth } from "hooks";

const ShipmentItemsTab = () => {
  const { isCustomer, isVendor, isContractor, isDriver, isVendorStaff } = useAuth();
  const canEdit = isCustomer || isVendor || isContractor || isDriver || isVendorStaff;

  const [showItemForm, setShowItemForm] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const { ShipmentDetail } = useShipmentDetailContext();
  const shipmentId = ShipmentDetail?._id;

  const [{ isLoading: updatingShipment }] = useUpdateShipmentMutation();

  const handleCancelItem = () => {
    setShowItemForm(false);
    setSelectedItem(null);
  };

  const handleSubmitItem = () => {
    setShowItemForm(false);
    setSelectedItem(null);
  };

  return (
    <>
      <Box display="flex" justifyContent="end" padding={3}>
        {!showItemForm && !canEdit && (
          <Button
            startIcon={<Add />}
            variant="outlined"
            disabled={ShipmentDetail?.isActive === false}
            onClick={() => setShowItemForm(true)}
          >
            Add Item
          </Button>
        )}
      </Box>
      <ShipmentItemsList />
      <FormDrawer
        title="Shipment Item"
        open={showItemForm}
        onClose={handleCancelItem}
      >
        <ShipmentItemsForm
          isBusy={updatingShipment}
          item={selectedItem}
          shipmentId={shipmentId}
          onCancel={handleCancelItem}
          onSubmit={handleSubmitItem}
        />
      </FormDrawer>
    </>
  );
};

export default ShipmentItemsTab;